/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FilterItem } from './';
import {
    FilterItemFromJSON,
    FilterItemFromJSONTyped,
    FilterItemToJSON,
} from './';
import type { PaginationResponse } from './';
import {
    PaginationResponseFromJSON,
    PaginationResponseFromJSONTyped,
    PaginationResponseToJSON,
} from './';
import type { ProfileResponse } from './';
import {
    ProfileResponseFromJSON,
    ProfileResponseFromJSONTyped,
    ProfileResponseToJSON,
} from './';

/**
 * Profiles matching the micro-consulting search, along with the job categories and industry expertises
 * offered as filters.
 * 
 * @export
 * @interface MicroConsultingProfilesResponse
 */
export interface MicroConsultingProfilesResponse {
    /**
     * 
     * @type {Array<ProfileResponse>}
     * @memberof MicroConsultingProfilesResponse
     */
    profiles: Array<ProfileResponse>;
    /**
     * 
     * @type {PaginationResponse}
     * @memberof MicroConsultingProfilesResponse
     */
    pagination: PaginationResponse;
    /**
     * Job categories the client can narrow the search down to, most represented first. Their `key` is
     * the category human id of the categorization ontology, as accepted by the `category` parameter.
     * 
     * Computed over the profiles matching the search, selected `category` and `businessSector`
     * included, exactly as keyword search computes its own category filters. Selecting a category
     * therefore narrows this list down to the categories its profiles also belong to.
     * 
     * @type {Array<FilterItem>}
     * @memberof MicroConsultingProfilesResponse
     */
    categoryFilters: Array<FilterItem>;
    /**
     * Industry expertises the client can narrow the search down to, most represented first. Their
     * `key` is the industry expertise human id, as accepted by the `businessSector` parameter.
     * 
     * Computed over the profiles matching the search, selected `category` and `businessSector`
     * included, exactly as keyword search computes its own business sector filters. Selecting an
     * industry expertise therefore narrows this list down to the ones its profiles also declare.
     * 
     * @type {Array<FilterItem>}
     * @memberof MicroConsultingProfilesResponse
     */
    businessSectorFilters: Array<FilterItem>;
}

/**
 * Check if a given object implements the MicroConsultingProfilesResponse interface.
 */
export function instanceOfMicroConsultingProfilesResponse(value: object): value is MicroConsultingProfilesResponse {
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('categoryFilters' in value) || value['categoryFilters'] === undefined) return false;
    if (!('businessSectorFilters' in value) || value['businessSectorFilters'] === undefined) return false;
    return true;
}

export function MicroConsultingProfilesResponseFromJSON(json: any): MicroConsultingProfilesResponse {
    return MicroConsultingProfilesResponseFromJSONTyped(json, false);
}

export function MicroConsultingProfilesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MicroConsultingProfilesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'profiles': ((json['profiles'] as Array<any>).map(ProfileResponseFromJSON)),
        'pagination': PaginationResponseFromJSON(json['pagination']),
        'categoryFilters': ((json['categoryFilters'] as Array<any>).map(FilterItemFromJSON)),
        'businessSectorFilters': ((json['businessSectorFilters'] as Array<any>).map(FilterItemFromJSON)),
    };
}

export function MicroConsultingProfilesResponseToJSON(value?: MicroConsultingProfilesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profiles': ((value['profiles'] as Array<any>).map((v) => ProfileResponseToJSON(v))),
        'pagination': PaginationResponseToJSON(value['pagination']),
        'categoryFilters': ((value['categoryFilters'] as Array<any>).map((v) => FilterItemToJSON(v))),
        'businessSectorFilters': ((value['businessSectorFilters'] as Array<any>).map((v) => FilterItemToJSON(v))),
    };
}

